"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var VocabSentencesWrapper = function VocabSentencesWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "sentencesLoaded", _descriptor, _this);
      _initializerDefineProperty(_this, "showSentenceSubmissionForm", _descriptor2, _this);
      _initializerDefineProperty(_this, "popupSentence", _descriptor3, _this);
      _initializerDefineProperty(_this, "limit", _descriptor4, _this);
      if (props.wordId) {
        _this.limit = 10;
      } else if (props.conceptId) {
        _this.limit = 6;
      }
      _this.getSentences();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.wordId !== this.props.wordId) {
          this.getSentences();
        } else if (prevProps.conceptId !== this.props.conceptId) {
          this.getSentences();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.wordSentenceStore.clearIndexData();
      }
    }, {
      key: "afterGetSentences",
      value: function afterGetSentences(resp) {
        var _this2 = this;
        this.sentencesLoaded = true;
        if (this.props.wordId) {
          _state.AppUI.wordSentenceStore.setIndexData(resp);
        } else if (this.props.conceptId) {
          _state.DeckUI.conceptSentenceStore.setIndexData(resp);
        }
        if ((0, _utils.isPresent)(this.props.popupSentenceId)) {
          this.popupSentence = _state.AppUI.wordSentenceStore.indexData.find(function (item) {
            return item.id === _this2.props.popupSentenceId;
          });
        }
      }
    }, {
      key: "onToggleShowSentenceSubmissionForm",
      value: function onToggleShowSentenceSubmissionForm() {
        this.showSentenceSubmissionForm = !this.showSentenceSubmissionForm;
      }
    }, {
      key: "onClickSentence",
      value: function onClickSentence(sentence) {
        this.popupSentence = sentence;
      }
    }, {
      key: "onToggleCreateReview",
      value: function onToggleCreateReview(id, wordReview) {
        if (!_state.AppUI.user.isMember && !_state.AppUI.layout.isNative) {
          _state.AppUI.routeStore.routeToNamed('memberships.index');
          return;
        }
        var reviewCard = this.reviewCard(id);
        if (reviewCard) {
          _state.AppUI.cardStore.destroy({
            ids: {
              cardId: reviewCard.id
            }
          }, this.getReviews);
        } else {
          _state.AppUI.cardStore.create({
            data: {
              card_type_slug: 'translate',
              user_id: _state.AppUI.user.id,
              word_id: wordReview ? id : null,
              sentence_id: wordReview ? null : id,
              language_id: _state.AppUI.targetLanguageId
            }
          }, this.getReviews);
        }
      }
    }, {
      key: "hasReview",
      value: function hasReview(id) {
        return (0, _utils.isPresent)(this.reviewCard(id));
      }
    }, {
      key: "reviewCard",
      value: function reviewCard(id) {
        return _state.AppUI.cardStore.indexData.find(function (item) {
          return item.word && item.word.id === id || item.sentence && item.sentence.id === id;
        });
      }
    }, {
      key: "getReviews",
      value: function getReviews() {
        // AppUI.cardStore.getIndex({queryStrings: {sentences_for_word: true}, filters: {user_id: AppUI.user.id, word_id: this.props.wordId}});
      }
    }, {
      key: "sentencesHaveVideo",
      get: function get() {
        return (0, _lodash.every)(_state.AppUI.wordSentenceStore.indexData.map(function (sentence) {
          var _sentence$target;
          return (_sentence$target = sentence.target) === null || _sentence$target === void 0 ? void 0 : _sentence$target.hasVideoClip;
        }));
      }
    }, {
      key: "getSentences",
      value: function getSentences() {
        if (this.props.wordId) {
          _state.AppUI.wordSentenceStore.getIndex({
            queryStrings: {
              vocab_trainer: true
            },
            limit: this.limit,
            sort: 'level_abbreviation, target_text',
            ids: {
              wordId: this.props.wordId
            }
          }, this.afterGetSentences);
        }
        if (this.props.conceptId) {
          _state.DeckUI.conceptSentenceStore.getIndex({
            sort: 'level_abbreviation, -created_at',
            limit: this.limit,
            ids: {
              conceptId: this.props.conceptId
            }
          }, this.afterGetSentences);
        }
        this.getReviews();
      }
    }, {
      key: "sentences",
      get: function get() {
        if (this.props.wordId) {
          return _state.AppUI.wordSentenceStore.indexData;
        }
        if (this.props.conceptId) {
          return _state.DeckUI.conceptSentenceStore.indexData;
        }
      }
    }, {
      key: "store",
      get: function get() {
        if (this.props.wordId) {
          return _state.AppUI.wordSentenceStore;
        }
        if (this.props.conceptId) {
          return _state.DeckUI.conceptSentenceStore;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentences: this.sentences,
          store: this.store,
          sentencesLoaded: this.sentencesLoaded,
          showSentenceSubmissionForm: this.showSentenceSubmissionForm,
          onToggleShowSentenceSubmissionForm: this.onToggleShowSentenceSubmissionForm,
          popupSentence: this.popupSentence,
          onClickSentence: this.onClickSentence,
          onToggleCreateReview: this.onToggleCreateReview,
          hasReview: this.hasReview,
          sentencesHaveVideo: this.sentencesHaveVideo,
          limit: this.limit
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "sentencesLoaded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showSentenceSubmissionForm", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "popupSentence", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "limit", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "afterGetSentences", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetSentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleShowSentenceSubmissionForm", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleShowSentenceSubmissionForm"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickSentence", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleCreateReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleCreateReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "hasReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentencesHaveVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentencesHaveVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getSentences", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getSentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "store", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "store"), _class2.prototype), _class2)) || _class;
};
VocabSentencesWrapper.displayName = 'VocabSentencesWrapper';
var _default = exports["default"] = VocabSentencesWrapper;